"use client";

import { Slider } from "@/components/ui/slider";
import { useTranslations } from "next-intl";
import { Dispatch, SetStateAction } from "react";

export interface CountUnitsProps {
  floors: number[];
  setFloors: Dispatch<SetStateAction<number[]>>;
  squareMeter: number[];
  setSquareMeter: Dispatch<SetStateAction<number[]>>;
  livingUnits: number[];
  setLivingUnits: Dispatch<SetStateAction<number[]>>;
  propertyType: "singleFamilyHouse" | "multiFamilyHouse";
}

const CountUnits = ({ ...props }: CountUnitsProps) => {
  const t = useTranslations("measurementService.priceCalculation");
  const isMultiFamily = props.propertyType === "multiFamilyHouse";

  return (
    <div className="m-auto flex w-full max-w-2xl flex-col gap-8">
      <div className="flex flex-col gap-6">
        <span className="text-ring text-sm">{t("floorsDescription")}</span>
        <div className="flex items-center gap-4">
          <span className="text-primary w-40 shrink-0 text-sm font-medium sm:text-base">
            {t("floors", { max: 10 })}
          </span>
          <div className="min-w-0 flex-1">
            <Slider
              className="w-full"
              defaultValue={[1]}
              min={1}
              max={10}
              step={1}
              value={props.floors}
              onValueChange={props.setFloors}
              showValue
            />
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-6">
        <span className="text-ring text-sm">{t("qmDescription")}</span>
        <div className="flex items-center gap-4">
          <span className="text-primary w-40 shrink-0 text-sm font-medium sm:text-base">
            {t("qm", { max: 1000 })}
          </span>
          <div className="min-w-0 flex-1">
            <Slider
              className="w-full"
              defaultValue={[15]}
              min={15}
              max={1000}
              step={1}
              value={props.squareMeter}
              onValueChange={props.setSquareMeter}
              showValue
              formatValue={(v) => `${v}m²`}
            />
          </div>
        </div>
      </div>
      {isMultiFamily && (
        <div className="flex flex-col gap-6">
          <span className="text-ring text-sm">{t("unitsDescription")}</span>
          <div className="flex items-center gap-4">
            <span className="text-primary w-40 shrink-0 text-sm font-medium sm:text-base">
              {t("units", { max: 25 })}
            </span>
            <div className="min-w-0 flex-1">
              <Slider
                className="w-full"
                defaultValue={[1]}
                min={1}
                max={25}
                step={1}
                value={props.livingUnits}
                onValueChange={props.setLivingUnits}
                showValue
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CountUnits;
